'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.getTranslateFunction = exports.localize = exports.setTranslations = exports.setFallbackLanguage = exports.setLanguage = exports.i18nState = exports.default = undefined;

var _reducer = require('./reducer');

Object.defineProperty(exports, 'i18nState', {
  enumerable: true,
  get: function get() {
    return _reducer.i18nState;
  }
});

var _actions = require('./actions');

Object.defineProperty(exports, 'setLanguage', {
  enumerable: true,
  get: function get() {
    return _actions.setLanguage;
  }
});
Object.defineProperty(exports, 'setFallbackLanguage', {
  enumerable: true,
  get: function get() {
    return _actions.setFallbackLanguage;
  }
});
Object.defineProperty(exports, 'setTranslations', {
  enumerable: true,
  get: function get() {
    return _actions.setTranslations;
  }
});

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _hoc = require('./hoc');

var _hoc2 = _interopRequireDefault(_hoc);

var _getTranslateFunction2 = require('./getTranslateFunction');

var _getTranslateFunction3 = _interopRequireDefault(_getTranslateFunction2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _component2.default;
exports.localize = _hoc2.default;
exports.getTranslateFunction = _getTranslateFunction3.default;